<!------------------------------------->
<!-- List tab detail layout.
 * File Name ..: agencydefinition.component.html
 * Generated by: ianday
 * Date .......: 10/10/23
--------------------------------------->
<div class="agencydefinition-form-container">
    <div class="query-strip-container mat-elevation-z2">
        <table height="100%">
            <TR>
                <TD class="table-title-cell">
                    <i class="fa fa-star fa-fw table-icon-header"
                       style="width: 2em"></i>{{formTitle}}
                </TD>
            </TR>
        </table>
    </div>

   <div class="main-client-area">
      	 <div class="dwform detail-container">
      	 
			 <div class="dwform-cell-nopadding right-border" style="min-width: 500px;width: 60%;padding-left: 20px"> <!--LHS Fields -->   
                  <div class="dwform-row-double-gap"></div>
                  <div class="dwform-row"> 
                  	 <label class="label-field">ID:</label> <span  class="form-required"> </span>
                     <input class="input-field-short" id="agencyId" style="width:80px"  disabled="true"  [(ngModel)]="id" type="text">
                     <span style="width: 100px;"></span>
 
                     <label style="margin-left: 109px;">Agency Code:</label>
	   				 <input class="input-field-shortest" id="id" [disabled]="!isEditing" [(ngModel)]="agencyCode" style="width: 85px;margin-left: 25px;" type="text">
                  </div>
                  <div class="dwform-row-gap"></div>
                  
                  <div class="dwform-row">
                  	<label class="label-field">Agency Name:</label><span class="form-required">*</span>
                  	<input class="input-field-longest" id="agencyName" [disabled]="!isEditing"
                                           style="text-transform: capitalize"
                                           [(ngModel)]="agencyName"
                                           placeholder="<Agency Name>"
                                           type="text">
                  </div>
                  <div class="dwform-row-gap"></div>
                  
                  <div class="dwform-row">
                  	<label class="label-field">Address:</label><span class="form-required">*</span>
                  	<input class="input-field-longest" id="address1" [disabled]="!isEditing"
                                               [(ngModel)]="address1"
                                               style="text-transform: capitalize"
                                               placeholder="<Address line 1>"
                                               type="text">
                  </div>
                  <div class="dwform-row-gap"></div>
                  
                  <div class="dwform-row">
                  	<label class="label-field"></label><span class="form-required"></span>
                  		<input class="input-field-longest" id="address2" [disabled]="!isEditing"
                                               [(ngModel)]="address2"
                                               style="text-transform: capitalize"
                                               placeholder="<Address line 2>"
                                               type="text">
                  </div>
                  <div class="dwform-row-gap"></div>
                  
                   <div class="dwform-row">
                  	<label class="label-field">City/St/Zip:</label>
                    <span class="form-required">*</span>
                    <input class="input-field" id="city"
                                           style="width: 260px;text-transform: capitalize;margin-right: 10px;" [disabled]="!isEditing"
                                           [(ngModel)]="city"
                                           placeholder="<City>"
                                           type="text">
							
							
								 <input class="input-field-shortest" id="state"
                                               maxLength="2"
                                               style="width:30px;text-transform: uppercase;"
                                               [disabled]="!isEditing"
                                               [(ngModel)]="state"
                                               placeholder=""
                                               type="text">
							
							
								 <input class="input-field-shortest" id="zipCode" [disabled]="!isEditing"
                                               [(ngModel)]="zipCode" style="width: 75px"
                                               maxlength="5"
                                               oninput="javascript: if (this.value.length > this.maxLength) this.value = this.value.slice(0, this.maxLength);"
                                               placeholder="<Zip>"
                                               type="number">
					</div>
					<div class="dwform-row-gap"></div>
                  	<div class="dwform-row">
                  		<label class="label-field">County:</label><span class="form-required">*</span>

                        <dw-dropdown
                            [disabled]="!isEditing"
                            [dataSource]="countyList"
                            [controlWidth]="'200px'"
                            [selectedItem]="county"
                            (itemSelected)="county = $event">

                        </dw-dropdown>

                  	</div>
                  	<div class="dwform-row-gap"></div>
                  	<div class="dwform-row-gap"></div>
                  	
                  	<hr class="divider" style="width: 90%;margin-left: 30px;">
                  	<div class="dwform-row-gap"></div>
                  	
                  	<h3>Contact Information:</h3>
                  	<div class="dwform-row-gap"></div>
                  	<div class="dwform-row">
                  		<label class="label-field">Primary Contact:</label><span class="form-required">*</span>
                  		<input class="input-field" [disabled]="!isEditing" id="primaryContact"
                                                   style="text-transform: capitalize"
                                                   [(ngModel)]="primaryContact"
                                                   placeholder="<Primary Contact>"
                                                   type="text">
                  	</div>
                  	<div class="dwform-row-gap"></div>
                  	
                  	<div class="dwform-row">
                  		<label class="label-field">Email:</label><span class="form-required">*</span>
                  		<input class="input-field" [disabled]="!isEditing" id="emailAddress"
                                                   [(ngModel)]="emailAddress"
                                                   placeholder="<Email Address>"
                                                   type="text">

                        <label class="label-field-half">Phone:</label>
                        <span class="form-required">*</span>
						<p-inputMask matInput class="input-field" id="phoneNumber"
                                                         [disabled]="!isEditing"
                                                         mask="(999) 999-9999"
                                                         [(ngModel)]="phoneNumber" placeholder="<Telephone>"
                                                         type="text">
                        </p-inputMask>

                  	</div>
                  	<div class="dwform-row-gap"></div>
                    <div class="dwform-row-gap"></div>

                 <div class="dwform-row">
                  		<label class="label-field">Second Contact:</label><span class="form-required"></span>
                  		 <input class="input-field" [disabled]="!isEditing" id="secondaryContact"
                                                   style="text-transform: capitalize"
                                                   [(ngModel)]="secondContact"
                                                   placeholder="<Second Contact>"
                                                   type="text">
                  	</div>
                  	<div class="dwform-row-gap"></div>
                  	
                  	<div class="dwform-row">
                  		<label class="label-field">Email:</label><span class="form-required"></span>
                  		 <input class="input-field" [disabled]="!isEditing" id="secondEmailAddress"
                                                   [(ngModel)]="emailAddress2"
                                                   placeholder="<Email Address>"
                                                   type="text">
						<label class="label-field-half">Phone:</label>
                        <span class="form-required"></span>
                        <p-inputMask matInput class="input-field" id="phoneNumber"
                                                         [disabled]="!isEditing"
                                                         mask="(999) 999-9999"
                                                         [(ngModel)]="phoneNumber2" placeholder="<Telephone>"
                                                         type="text">
                        </p-inputMask>
                  	</div> 
                  	
              </div>   
              
                <div class="dwform-cell-nopadding" style="min-width: 400px;padding-left: 20px;">  <!--RHS Fields -->
                  <div class="dwform-row"> 
                  	 <h3>Availability:</h3>
                  </div>
                  <div class="dwform-row-gap"></div>
                  	
                  <div *ngIf="statusVisibility" class="dwform-row">
                  	<label class="label-field">Status:</label>
                    <span class="form-required">*</span>

					  <dw-dropdown 
							  id="activeStatusId"
							  [disabled]="!isEditing || !statusActive"
							  [selectedItem]="activeStatus"
							  (itemSelected)="activeStatus = $event"
							  [controlWidth]="'120px'" [useStatusOptions]="'status'">
					  </dw-dropdown>

                  </div>	
                  <div *ngIf="statusVisibility" class="dwform-row-gap"></div>
                    
                  <div class="dwform-row">
                  	<label class="label-field" style="vertical-align: top">Hours of Operation:</label>
                      <span class="form-required"></span>
                     <textarea [(ngModel)]="hoursOfOperation"
                               [disabled]="!isEditing"
                               placeholder="<Describe your agency's hours of operation>"
                               class="text-area-input text-area-override"></textarea>

                  </div>

                  <div class="dwform-row-gap"></div>
                  <div class="dwform-row-gap"></div>
                  <div class="dwform-row-gap"></div>
                  <hr style="margin-top: 10px;width: 85%" class="divider">
				  <div class="dwform-row-gap"></div>

                    <h3 *ngIf="usersActive">User Management:</h3>
                    <div class="dwform-row-gap"></div>
                    <div  class="dwform-row">
                        <label class="label-field">Current Users:</label>
                        <span style="margin-left: 10px;margin-right: 74px;">{{userCount}}</span>
                        <button *ngIf="usersActive" style="margin-left: 100px; width:100px" class="command-button"
                            (click)="openAgencyUsersDialog()" [disabled]="id<1"
                            matTooltip="Manage users for this agency"  mat-button>
                                <mat-icon>person_outline</mat-icon>
                                    Users
                        </button>
                    </div>

                </div>
                </div>

           <!-- Error line is non-standard given that we have a custom form -->
           <div class="error-line error-line-override" [hidden]='!strErr.length'
            style="width: fit-content">{{strErr}}</div>
           <div class=" error-line-override" style="height:26px;" [hidden]='strErr.length'></div>

           <!-- save and close strip -->
           <div class="save-close-strip" 
                 style="position:relative;">
                <button mat-button class="command-button" *ngIf="!this.isEditing && editButtonVisibility"
                        (click)="modifyClickHandler()"
                         matTooltip="Edit the details"
                        mat-button>
                    <mat-icon>edit</mat-icon>
                    Edit
                </button>
                 <button mat-button class="command-button" *ngIf="this.isEditing"
                         matTooltip="Save the record" (click)="saveClickHandler()"
                        mat-button>
                    <mat-icon>check_circle_outline</mat-icon>
                    Submit
                </button>
                <button mat-button class="command-button" *ngIf="this.isEditing" (click)="cancelClickHandler()"
                         matTooltip="Cancel edits" mat-button>
                    <mat-icon>highlight_off</mat-icon>
                    Cancel
                </button>
          </div>
   </div>
</div>
   
<p-dialog *ngIf="displayAgencyUsers" [resizable]="false"
         [maxHeight]="'98%'" [appendTo]="'body'" header="{{headerUsers}}" [(visible)]="displayAgencyUsers"
         [modal]="true" [style]="{width: '96%', maxHeight:'98%', zIndex:'2001'}"
         [contentStyle]="{paddingBottom: '0rem'}"  [autoZIndex]="true">
    <app-usermanagement #users  [agencyView]="true" [agencyId]="id"
                      (closeAgencyEvent)="displayAgencyUsers=false">
    </app-usermanagement>
</p-dialog>
